import React, { PureComponent } from 'react';
import errorBoundary from '@ifeng-fe/errorBoundary';
import PropTypes from 'prop-types';

import styles from './index.css';

import { classNames } from '@ifeng-fe/container_channel/common/client/utils/classnames';

import Rules from './rules';

import Judges from './judges';

/**
 * 区域盛典
 */
class NavBar extends PureComponent {
    static propTypes = {
        content: PropTypes.object,
        onChange: PropTypes.func,
        searchValue: PropTypes.string,
        onSeach: PropTypes.func,
        onClear: PropTypes.func,
        curArea: PropTypes.string,
    };

    onKeyDown = e => {
        // console.log(e.keyCode);

        if (Number(e.keyCode) === 13) {
            this.props.onSeach();
        }
    };

    handleClear = () => {
        this.props.onClear();
    };

    render() {
        const {
            searchValue,
            onChange,
            onSeach,
            content: { rule, judgesByArea },
            curArea,
        } = this.props;

        return (
            <div className={classNames(styles.navBar, 'clearfix')}>
                <div className={styles.header}>美食餐厅</div>
                <Rules content={rule} />
                {/* <div className={styles.other}>评委阵容</div> */}
                <Judges curArea={curArea} content={judgesByArea} />

                <div className={classNames(styles.search, 'clearfix')}>
                    <div className={styles.input}>
                        <input
                            type="text"
                            placeholder="输入名称/编号"
                            onChange={e => onChange(e.target.value)}
                            onKeyDown={this.onKeyDown}
                            value={searchValue}
                        />
                        <span className={styles.search_icon} onClick={onSeach} />
                    </div>
                    <div className={styles.goback} onClick={this.handleClear}>
                        返回
                    </div>
                </div>
            </div>
        );
    }
}

export default errorBoundary(NavBar);
